<template>
  <div>
    <PageHeader v-if="!isMobile" :title="tagName" :link="{ path: '/', label: 'EER' }" />
    <div :class="['max-w-6xl mx-auto px-4 mt-24']">
      <h1 :class="['text-center', isMobile ? 'mb-4' : 'mb-12']">{{ tagName }}</h1>
      <IndexTable
        :items="results"
        :columns="columns"
        :defaultSortBy="'begin_date'"
        :defaultSortAsc="false"
        :hideSortMobile="menuOpen"
      />
      <PageFooter />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formatDateOrRange } from '@/util'
import PageHeader from '@/components/PageHeader.vue'
import IndexTable from '@/components/IndexTable.vue'
import PageFooter from '@/components/PageFooter.vue'

export default {
  name: 'Tag',

  components: {
    PageHeader,
    IndexTable,
    PageFooter
  },

  computed: {
    ...mapState(['tags', 'isMobile', 'menuOpen']),

    tagName () {
      return decodeURI(this.$route.params.slug)
    }
  },

  data () {
    return {
      tag: false,
      results: [],
      columns: [
        {
          key: 'cover_image',
          label: ''
        },
        {
          key: 'title',
          label: 'Title'
        },
        {
          key: 'date',
          label: 'Date'
        },
        {
          key: 'type',
          label: 'Type'
        }
      ]
    }
  },

  async mounted () {
    const tagName = this.$route.params.slug
    await this.$store.dispatch('getTag', tagName)
    this.results = this.tags[tagName].map(a => {
      a.date = a.begin_date
      a.dateDisplay = formatDateOrRange(a.begin_date, a.end_date)
      return a
    })
  }
}
</script>
